import styled from 'styled-components';
import ProductsInCart from 'ggApp/modules/auth/v3/components/ProductsInCart';

export const StepContainer = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    padding: 16px;
    min-height: calc(100% - 8px);
    max-height: initial;

    .productInCheckout {
        padding: 0;
        margin: 0 0 32px;
    }

    .checkoutModalLoader {
        display: flex;
        flex: 1 1 auto;
    }

    ${({ theme }) => theme.superQuery.all.and.minWidth.desktopMin.css`
        padding: 24px;
    `};
`;

export const ProductsInCartContent = styled(ProductsInCart)`
    flex-shrink: 0;
`;
